import { render, staticRenderFns } from "./FormulaReferences.vue?vue&type=template&id=6b8c1964&scoped=true"
import script from "./FormulaReferences.vue?vue&type=script&lang=js"
export * from "./FormulaReferences.vue?vue&type=script&lang=js"
import style0 from "./FormulaReferences.vue?vue&type=style&index=0&id=6b8c1964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c1964",
  null
  
)

export default component.exports